import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { getConfig, searchAPI } from "../../apis";
import Footer2 from "../../layout/Footer/Footer2";
import Sidebar from "../../layout/Sidebar";
import SidebarOpen from "../../layout/SidebarOpen";
import {
  setnewsData,
  setsearch,
  setBookmarkUrls,
  setCollections,
  setCitationPopup,
  setAcademiaSearch,
  setDatePicker,
  setAcademiaSearchList,
  setAcademiaData,
  setsidebarData,
  setsidebarDataCopy,
} from "../../redux/features/dataSlice";
import SectionNews from "./uis/SectionNews";
import NewsRating from "./uis/SectionNews/NewsRating";
import CustomLoader from "../../components/loader";
import Datepicker from "../../components/datepicker/Datepicker";
import PopupSave from "./uis/SectionNews/PopupSave";
import { toast } from "react-toastify";
import CustomSummarize from "./uis/SectionNews/CustomSummarize";
import NewBookmark from "../NewsCategoryPage/NewBookmark";
import PopupCitation from "../SavedPage/popup/PopupCitation";
import Summarize from "./uis/SectionNews/Summarize";
import { axiosInstance } from "../../functions/axios";
import VimeoPlayer from "../../components/VimeoPlayer/VideoPlayer";
import { subtractYearsAndGetFormattedDate } from "../../functions/time";
import useDocumentTypes from "../../hooks/useDocumentTypes";

const NewsPage = () => {
  const dispatch = useDispatch();
  const { query } = useParams();
  const params = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { sidebarActive, popupCardFooter } = useSelector(
    (state) => state.styles
  );
  const { user } = useSelector((state) => state.auth);
  useDocumentTypes(user.userId);

  const {
    sidebarData,
    newsData,
    datePicker,
    bookmarkUrls,
    summarizePopup,
    fromDate,
    toDate,
    summaryPopup,
    citationPopup,
    academiaSearch,
    academiaSearchList,
    academiaData,
    sidebarDataCopy,
  } = useSelector((state) => state.data);

  const [loading, setloading] = useState(true);
  const [range, setRange] = useState(null);
  const [shouldFetchData, setShouldFetchData] = useState(true);
  const [newBookmarkPopup, setNewBookmarkPopup] = useState(false);
  const [saveBookmarkPopup, setSaveBookmarkPopup] = useState(false);
  const [bookmarkdata, setBookmarkData] = useState({});
  const [selectedCollection, setselectedCollection] = useState();
  const [desc, setDesc] = useState("");
  const [isDescExternal, setIsDescExternal] = useState(false);
  const [summaryText, setSummaryText] = useState("");
  const [summarizePopupNa, setSummarizePopupNa] = useState();
  const [articleData, setArticleData] = useState({});
  const [citation, setCitation] = useState("");
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  const date = new Date();
  const currentDate = `${date.getFullYear()}-${(
    "0" +
    (date.getMonth() + 1)
  ).slice(-2)}-${("0" + date.getDate()).slice(-2)}`;

  const formatCustomDate = () => {
    if (!fromDate || !toDate) return "";
    return `${fromDate.getFullYear()}-${("0" + (fromDate.getMonth() + 1)).slice(
      -2
    )}-${("0" + fromDate.getDate()).slice(-2)}..${toDate.getFullYear()}-${(
      "0" +
      (toDate.getMonth() + 1)
    ).slice(-2)}-${("0" + toDate.getDate()).slice(-2)}`;
  };
  const customDate = `${formatCustomDate()}`;

  const currentDateMinusOne = subtractYearsAndGetFormattedDate(date, 1);
  const currentDateMinusTwo = subtractYearsAndGetFormattedDate(date, 2);
  const currentDateMinusThree = subtractYearsAndGetFormattedDate(date, 3);

  const filterValue = {
    "Past 24 hours": "Day",
    "Past Week": "Week",
    "Past Month": "Month",
    "Past Year": `${currentDateMinusOne}..${currentDate}`,
    "Past 2 Years": `${currentDateMinusTwo}..${currentDate}`,
    "Past 3 years": `${currentDateMinusThree}..${currentDate}`,
    "All time": "",
    "Custom Date": `${customDate}`,
  };

  const filterTerm = searchParams.get("filter");

  const updateBookmarks = (url) => {
    if (!bookmarkUrls.includes(url)) {
      const newUrls = [...bookmarkUrls, url];
      setBookmarkUrls(newUrls);
    }
  };

  const handleDataFetch = () => {
    setShouldFetchData(true);
  };

  async function getData() {
    if (!sidebarData) {
      return;
    }
    setloading(true);

    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    let newsDataObj = {};
    const promises = sidebarData.map(async (item) => {
      const res = await axiosInstance.post(
        searchAPI.search,
        {
          SearchTerm: query,
          Media: item.categoryName_chr,
          timePeriod: filterValue[filterTerm],
          Count: "21",
          Offset: "0",
          userId: user.userId,
        },
        config
      );

      newsDataObj = {
        ...newsDataObj,
        [item.categoryName_chr]: res.data.data,
      };
    });

    await Promise.all(promises);

    dispatch(setnewsData(newsDataObj));

    setloading(false);
  }

  async function getCollectionData() {
    const res = await axiosInstance.post(
      searchAPI.getCollections,
      {
        callingUserId: user.userId,
        userId: user.userId,
      },
      getConfig()
    );

    let newArr = [];
    res.data.forEach((item) =>
      newArr.push({
        name: item.collectionName_chr,
        value: item.collectionName_chr,
        collectionId: item.collectionID_ids,
        parentCollectionId: item.parentCollectionID_lng,
      })
    );
    newArr = newArr.reverse();
    dispatch(setCollections(newArr));
    setselectedCollection(JSON.stringify(newArr[0]));
  }

  const getBookmarks = async () => {
    const res = await axiosInstance.post(
      searchAPI.getCollectionsSource,
      {
        callingUserId: user.userId,
        userId: user.userId,
      },
      getConfig()
    );
    dispatch(
      setBookmarkUrls(res.data.map((bookmark) => bookmark.sourceUrl_chr))
    );
  };

  const saveCollectionFolder = async (name) => {
    const requestsData = {
      callingUserId: user.userId,
      userId: user.userId,
      collectionName: name,
    };
    await axiosInstance.post(
      searchAPI.updateCollections,
      requestsData,
      getConfig()
    );
    getCollectionData();

    setNewBookmarkPopup(false);
  };

  const handleSavedCollection = async (bookmarkId) => {
    try {
      const json_res = {
        ...articleData,
        collectionSourceId: bookmarkId,
        userId: user.userId,
        citation: citation,
      };
      const res = await axiosInstance.post(
        searchAPI.saveCitation,
        json_res,
        getConfig()
      );

      toast.success("Citation saved successfully!");
    } catch (e) {
      console.log(e);
    }
  };

  const getAcademiaSearchList = async () => {
    try {
      const { data } = await axiosInstance.post(
        searchAPI.academiaSearchList,
        {
          userId: user.userId,
        },
        getConfig()
      );
      dispatch(setAcademiaSearchList(data));
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    if (popupCardFooter) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [popupCardFooter]);

  const getAcademiaData = async () => {
    const option = academiaSearchList.filter(
      (academia) => academia.categoryName_chr === academiaSearch
    )[0];
    try {
      let academiaDataObj = {};
      if (option.academiaId_ids !== 6) {
        const res = await axiosInstance.post(
          searchAPI.academiaSearch,
          {
            query: query,
            limit: "10",
            offset: "0",
            userId: user.userId,
            academiaId: option.academiaId_ids,
          },
          getConfig()
        );
        const arr = res.data.data;

        academiaDataObj = {
          [option.categoryName_chr]: arr,
        };
        dispatch(setAcademiaData(academiaDataObj));
      }
    } catch (e) {
      console.log(e);
    }
  };

  async function getSidebarData() {
    try {
      const sidebar = await axiosInstance.post(searchAPI.sidebar, {
        callingUserId: user?.userId,
        userId: user?.userId,
        includeDeletedRecords: 0,
      });
      dispatch(setsidebarData(sidebar.data));
      dispatch(setsidebarDataCopy(sidebar.data));
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    dispatch(setAcademiaSearch("Academia"));
    if (!sidebarData) {
      getSidebarData();
    }
    getAcademiaSearchList();
  }, []);

  useEffect(() => {
    dispatch(setsearch(query));
    getData();
  }, [query, filterTerm, sidebarDataCopy]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const newRange = queryParams.get("range");

    if (newRange !== range) {
      setRange(newRange);
      dispatch(setsearch(query));
      getData();
    }
  }, [location.search]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [loading]);

  useEffect(() => {
    if (shouldFetchData) {
      getBookmarks();
      setShouldFetchData(false);
    }

    getBookmarks();
  }, [shouldFetchData]);

  useEffect(() => {
    dispatch(setDatePicker(false));
  }, []);
  useEffect(() => {
    getAcademiaData();
  }, [academiaSearchList, location.pathname]);

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <div className="news-page">
      {datePicker && <Datepicker />}
      {selectedVideoId && (
        <VimeoPlayer
          selectedVideoId={selectedVideoId}
          setSelectedVideoId={setSelectedVideoId}
        />
      )}
      <Sidebar />
      <SidebarOpen />
      <div className={`main ${sidebarActive ? "sidebar-active" : ""}`}>
        <div className="page-wrapper">
          <h3 className="custom-date">{searchParams.get("range")}</h3>

          {sidebarData.map(
            (item, i) =>
              !item.isHidden_ysn &&
              (item.categoryName_chr === "Academia" ? (
                <SectionNews
                  key={item.categoryName_chr}
                  data={
                    academiaSearch === "Academia"
                      ? newsData[item.categoryName_chr].webPages
                        ? newsData[item.categoryName_chr].webPages.value
                        : []
                      : academiaData[academiaSearch]?.results
                  }
                  title={item.categoryName_chr}
                  info={item.description_chr}
                  ugc={item.note_chr}
                  bookmarkUrls={bookmarkUrls}
                  updateBookmarks={updateBookmarks}
                  setBookmarkData={setBookmarkData}
                  setSaveBookmarkPopup={setSaveBookmarkPopup}
                />
              ) : (
                <SectionNews
                  key={item.categoryName_chr}
                  data={
                    newsData[item.categoryName_chr].webPages
                      ? newsData[item.categoryName_chr].webPages.value
                      : []
                  }
                  title={item.categoryName_chr}
                  info={item.description_chr}
                  ugc={item.note_chr}
                  bookmarkUrls={bookmarkUrls}
                  updateBookmarks={updateBookmarks}
                  setBookmarkData={setBookmarkData}
                  setSaveBookmarkPopup={setSaveBookmarkPopup}
                />
              ))
          )}
        </div>
        {popupCardFooter && <NewsRating />}
        {summaryPopup && (
          <CustomSummarize
            setDesc={setDesc}
            setIsDescExternal={setIsDescExternal}
            setSummaryText={setSummaryText}
            summaryText={summaryText}
            setSummarizePopupNa={setSummarizePopupNa}
          />
        )}
        {summarizePopup && (
          <Summarize
            setSaveBookmarkPopup={setSaveBookmarkPopup}
            desc={desc}
            setDesc={setDesc}
            isDescExternal={isDescExternal}
            setIsDescExternal={setIsDescExternal}
            setSummaryText={setSummaryText}
            summaryText={summaryText}
            summarizePopupNa={true}
            setSummarizePopupNa={() => {}}
          />
        )}
        {newBookmarkPopup && (
          <NewBookmark
            saveCollectionFolder={saveCollectionFolder}
            newBookmarkPopup={newBookmarkPopup}
            setNewBookmarkPopup={setNewBookmarkPopup}
          />
        )}
        <PopupSave
          data={bookmarkdata}
          bookmarkUrls={bookmarkUrls}
          handleDataFetch={handleDataFetch}
          setNewBookmarkPopup={setNewBookmarkPopup}
          selectedCollection={selectedCollection}
          setselectedCollection={setselectedCollection}
          popup={saveBookmarkPopup}
          setpopup={setSaveBookmarkPopup}
          desc={desc}
          setData={setBookmarkData}
          handleSavedCollection={handleSavedCollection}
        />
        {citationPopup && (
          <PopupCitation
            citationPopup={citationPopup}
            setCitationPopup={setCitationPopup}
            setBookmarkData={setBookmarkData}
            setSaveBookmarkPopup={setSaveBookmarkPopup}
            articleData={articleData}
            setArticleData={setArticleData}
            citation={citation}
            setCitation={setCitation}
          />
        )}
      </div>

      <Footer2 setSelectedVideoId={setSelectedVideoId} />
    </div>
  );
};

export default NewsPage;
